import React from "react";
import BottomSheet from "./BottomSheet";
import css from "./partnersMobile.module.css";

// Destructive actions get danger styling, matching partners-module.html.
const DANGER_LABELS = new Set(["Reject", "Suspend"]);

// The container's menus come in two shapes and we must accept both, exactly as
// ThreeDotsMenu does: tempSideMenuArrayCP holds {label, value} objects, while
// the FOS and disabled-row menus hold plain strings.
function normalise(item) {
  return typeof item === "string" ? { label: item, value: item } : item;
}

export default function ActionSheet({ open, title, items, onSelect, onClose }) {
  const list = (items ?? []).map(normalise).filter(Boolean);

  return (
    <BottomSheet open={open} title={title} onClose={onClose}>
      {list.length === 0 && (
        <div style={{ padding: "12px 0", color: "#667085", fontSize: 14 }}>
          No actions available.
        </div>
      )}
      {list.map((item) => (
        <button
          key={item.label}
          type="button"
          className={`${css.sheetOption} ${
            DANGER_LABELS.has(item.label) ? css.sheetOptionDanger : ""
          }`}
          onClick={() => {
            onSelect(item);
            onClose();
          }}
        >
          {item.label}
        </button>
      ))}
    </BottomSheet>
  );
}
